import React from "react";

const HomeService = ({ width = "38", height = "28", fill = "#BEBEBE" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 38 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.97498 2.31506H25.67V18.0001H16.175C15.705 16.6751 14.445 15.7201 12.96 15.7201C11.475 15.7201 10.21 16.6751 9.74498 18.0001H5.97498V14.9351H4.47498V19.5001H9.56498C9.74998 21.2101 11.2 22.5451 12.955 22.5451C14.71 22.5451 16.16 21.2101 16.345 19.5001H28.325C28.51 21.2101 29.96 22.5451 31.715 22.5451C33.47 22.5451 34.92 21.2101 35.105 19.5001H36.9V13.3501L32.55 6.54006H27.16V0.810059H4.47498V4.43006H5.97498V2.31006V2.31506ZM12.96 21.0451C11.905 21.0451 11.045 20.1851 11.045 19.1301C11.045 18.0751 11.905 17.2151 12.96 17.2151C14.015 17.2151 14.875 18.0751 14.875 19.1301C14.875 20.1851 14.015 21.0451 12.96 21.0451ZM31.725 21.0451C30.67 21.0451 29.81 20.1851 29.81 19.1301C29.81 18.0751 30.67 17.2151 31.725 17.2151C32.78 17.2151 33.635 18.0751 33.635 19.1301C33.635 20.1851 32.775 21.0451 31.725 21.0451ZM35.415 18.0001H34.945C34.475 16.6751 33.215 15.7201 31.73 15.7201C30.245 15.7201 28.98 16.6751 28.515 18.0001H27.18V12.3751H34.515L35.42 13.7901V18.0001H35.415ZM31.745 8.04006L33.555 10.8751H27.175V8.04006H31.745Z"
        fill={fill}
      />
      <path
        d="M31.725 17.77C30.975 17.77 30.36 18.38 30.36 19.135C30.36 19.89 30.97 20.5 31.725 20.5C32.48 20.5 33.09 19.89 33.09 19.135C33.09 18.38 32.48 17.77 31.725 17.77ZM31.59 19.135C31.59 19.06 31.65 19 31.725 19C31.8 19 31.86 19.06 31.86 19.135C31.86 19.285 31.59 19.285 31.59 19.135Z"
        fill={fill}
      />
      <path
        d="M12.96 17.77C12.21 17.77 11.595 18.38 11.595 19.135C11.595 19.89 12.205 20.5 12.96 20.5C13.715 20.5 14.325 19.89 14.325 19.135C14.325 18.38 13.715 17.77 12.96 17.77ZM12.825 19.135C12.825 19.06 12.885 19 12.96 19C13.035 19 13.095 19.06 13.095 19.135C13.095 19.285 12.825 19.285 12.825 19.135Z"
        fill={fill}
      />
      <path d="M13.34 9.125H1.41998V10.625H13.34V9.125Z" fill={fill} />
      <path d="M15.875 6.08508H6.23999V7.58508H15.875V6.08508Z" fill={fill} />
      <path d="M11.815 12.17H4.20996V13.67H11.815V12.17Z" fill={fill} />
      <path d="M31.595 23.3251H3.44995V24.8251H31.595V23.3251Z" fill={fill} />
      <path
        d="M2.18498 23.3251H0.724976V24.8251H2.18498V23.3251Z"
        fill={fill}
      />
      <path d="M37.275 25.6851H23.16V27.1851H37.275V25.6851Z" fill={fill} />
    </svg>
  );
};

export default HomeService;
